<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="800px">
    <v-card>
      <v-card-text class="text--primary">
        <v-autocomplete
          :items="oracles"
          label="Select An Oracle"
          item-text="title"
          item-value="id"
          v-model="selectedOracleID"
        />
        <OracleDisplay v-if="selectedOracleID" :oracleID="selectedOracleID" />
      </v-card-text>
      <v-card-actions v-if="selectedOracleID">
        <v-row justify="space-between" class="text-center">
          <v-col>
            <v-btn
              @click="askOracle"
              :disabled="!selectedOracleID"
              color="primary"
              ><v-icon left>mdi-comment-question-outline</v-icon>Ask</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  import OracleDisplay from '@/components/OracleDisplay.vue';

  export default {
    name: 'OraclesDialog',
    props: ['value'],
    components: {OracleDisplay},
    watch: {
      value() {
        this.reset();
      },
    },
    computed: {
      ...mapState('oracle', ['oracles', 'oraclesCategories']),
      ...mapGetters('oracle', ['oracleByID']),
      selectedOracle() {
        return this.oracleByID(this.selectedOracleID);
      },
    },
    methods: {
      askOracle() {
        this.$store.dispatch('oracle/ask', {
          oracleID: this.selectedOracle.id,
        });
        this.close();
      },
      close() {
        this.reset();
        this.$emit('input', false);
      },
      reset() {},
    },
    data() {
      return {
        selectedOracleID: '',
      };
    },
  };
</script>
